import { useApi } from '@root/src/web/lib/api';
export const useDiscussion = (url) => {
    const { data } = useApi(url);
    return {
        commentCount: data?.discussion?.commentCount,
        isClosedForComments: data?.discussion?.isClosedForComments,
    };
};
